export enum PracticeCompletion {
    Informmation = 1,
    Bio = 2,
    Photos = 3,
    Complete = 4
}
